const PREFIX = "Shared/Deal/";

export const RECEIVE_DEAL = `${PREFIX}RECEIVE_DEAL`;
export const RECEIVE_DEALS = `${PREFIX}RECEIVE_DEALS`;
